module.exports = __webpack_public_path__ + "static/media/subject discipline.edc40400.svg";